interface IUser {
  token: string;
  id: number;
  locale: string;
  email: string;
  name: string;
  entityType: string;
  attendantEmail: string;
  attendantId: number;
  expires_at: number;
}

export function getUserData(): IUser {
  const { profile, id_token: token, expires_at } = JSON.parse(localStorage.getItem('cas-js:user') || '{}');
  return { ...profile, expires_at, token };
}

export function getTokenKey(): string {
  return isOriginHelpCenter() ? 'cas-js:user' : 'token';
}

export function getToken(): string {
  const key = getTokenKey();
  if (isOriginHelpCenter()) {
    const { token } = getUserData();
    return token;
  }
  return localStorage.getItem(key) || '';
}

export function isOriginHelpCenter(): boolean {
  return window.location.origin.includes('help');
}

export function hasExpiredToken(): boolean {
  const { expires_at } = getUserData();
  if (!expires_at) {
    return false;
  }
  return checkPastDate(expires_at);
}

export function checkPastDate(expires_at: number): boolean {
  return new Date(expires_at * 1000) < new Date();
}
